import React from 'react';
import PropTypes from 'prop-types';
// 1. Swap Polyglot HOC for modern i18next hook
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Modal from '../Modal';
import { PrimaryButton } from '../buttons';
import FormFeedback from '../form/FormFeedback';

import './DiaryForgotPinModal.scss';

const DiaryForgotPinModal = ({
  isFailureMessageVisible = false,
  isLoading = false,
  isOpen = false,
  isSuccessMessageVisible = false,
  onRequestClose = () => {},
  onSubmit = () => {}
}) => {
  // 2. Initialize the translation hook
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isLoading) {
      onRequestClose();
    }
  };

  return (
    <Modal
      className={classNames('diary-forgot-pin-modal', {
        'diary-forgot-pin-modal--success': isSuccessMessageVisible
      })}
      isOpen={isOpen}
      onRequestClose={handleClose}
      showCloseButton={!isLoading}
    >
      {isSuccessMessageVisible ? (
        <>
          <h2>{t('diaryForgot.sentTitle')}</h2>
          <p>{t('diaryForgot.sentDescription')}</p>
          <p>{t('diaryForgot.sentDelay')}</p>
        </>
      ) : (
        <>
          <h2>{t('diaryForgot.title')}</h2>
          <p>{t('diaryForgot.description')}</p>
          
          {isFailureMessageVisible && (
            <FormFeedback positive={false}>
              {t('diaryForgot.failureDescription')}
            </FormFeedback>
          )}

          <PrimaryButton
            onClick={onSubmit}
            disabled={isLoading}
            loading={isLoading}
          >
            {t('diaryForgot.button')}
          </PrimaryButton>
        </>
      )}
    </Modal>
  );
};

// 3. Updated PropTypes (t removed)
DiaryForgotPinModal.propTypes = {
  isFailureMessageVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSuccessMessageVisible: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onSubmit: PropTypes.func
};

export default DiaryForgotPinModal;
